import { ApiQueryKey } from '@/configs/ApiQueryKey';
import EntityApi, { BaseEntity } from './EntityApi';
import { Order } from '@/api/OrdersApi';
import { QueryFunctionContext } from '@tanstack/react-query';
import { UUID } from '@/types/types';
import httpClient from '@/api/httpClient';

export enum PaymentMethodsEnum {
	IMOJE = 'imoje'
}

export enum TransactionStatusEnum {
	PENDING = 'pending',
	ACCEPTED = 'accepted',
	REJECTED = 'rejected',
}

export interface Transaction extends BaseEntity {
	amount: number;
	externalID: string;
	paymentMethod: PaymentMethodsEnum;
	status: TransactionStatusEnum;
	order: Order;
}

class TransactionsApi extends EntityApi<Transaction> {
	constructor() {
		super(ApiQueryKey.transactions);
	}

	async getOneByExternalId({ queryKey }: QueryFunctionContext<[ApiQueryKey, UUID]>) {
		const response = await httpClient.get<Transaction>(
			`${queryKey[0]}/external/${queryKey[1]}`
		);

		return response.data;
	}
}

export default new TransactionsApi();
